import theme from 'src/theme';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 16px'
  },
  paper: {
    width: 600,
    maxHeight: '96%',
    overflow: 'scroll',
    backgroundColor: theme.palette.background.default,
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    padding: '20px 20px 28px 20px',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: '36px'
  },
  closeIcon: {
    width: 11.67,
    height: 11.67,
    color: theme.palette.icon.close,
  },
  primaryTextColor: {
    color: theme.palette.text.primary,
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 8
  },
  inputField: {
    fontSize: 14,
    color: theme.palette.text.primary,
    border: 0,
    backgroundColor: '#E9E9E9',
    padding: '8px',
    flex: 1,
    margin: '0px',
    borderRadius: 4
  },
  checkIcon: {
    color: '#4caf50'
  },
};

export default styles;
